var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19965 0.705452L9.3 0.699219C9.70784 0.699219 10.0444 1.00441 10.0938 1.39887L10.1 1.49922V9.19922H17.8C18.2078 9.19922 18.5444 9.50441 18.5938 9.89887L18.6 9.99922C18.6 10.4071 18.2948 10.7436 17.9004 10.793L17.8 10.7992H10.1V18.4992C10.1 18.9071 9.79481 19.2436 9.40035 19.293L9.3 19.2992C8.89216 19.2992 8.5556 18.994 8.50623 18.5996L8.5 18.4992V10.7992H0.8C0.392159 10.7992 0.0555984 10.494 0.00623314 10.0996L0 9.99922C0 9.59138 0.305188 9.25482 0.69965 9.20545L0.8 9.19922H8.5V1.49922C8.5 1.09138 8.80519 0.754817 9.19965 0.705452L9.3 0.699219L9.19965 0.705452Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.d040c397a176d0cf50baea4363d7e58a.svg";
export { ForwardRef as ReactComponent };